<template>
  <DialogContainer
    :showDialog="showDialog"
    title="Filter Equipment"
    icon="filter_list"
    :toolbarActions="[
      {
        text: 'Filter Equipment',
        icon: 'filter_list',
        buttonColor: 'primary',
        emitEvent: 'onSubmitClicked',
        showIsLoading: true,
      },
      {
        text: 'Cancel',
        depressed: true,
        emitEvent: 'onCancelClicked',
      },
    ]"
    @onCancelClicked="onCancelClicked"
    @onSubmitClicked="onSubmitClicked"
    :isLoading="isLoading"
  >
    <v-container pa-0 grid-list-lg>
      <v-layout wrap>
        <v-flex xs12>
          <ControlAutoComplete
            :items="enabledAssetStatusList"
            autocomplete
            multiple
            item-text="name"
            item-value="id"
            v-model="statusIds"
            clearable
            label="Status"
            :disabled="isLoading"
          />
        </v-flex>
        <v-flex xs12>
          <ControlAutoComplete
            :items="enabledActivityTypeList"
            autocomplete
            multiple
            item-text="name"
            item-value="id"
            v-model="activityTypeIds"
            clearable
            label="Last Activity"
            :disabled="isLoading"
          />
        </v-flex>
        <v-flex xs12>
          <ControlAutoComplete
            :items="enabledModelList"
            autocomplete
            multiple
            item-text="name"
            item-value="id"
            v-model="modelIds"
            clearable
            label="Models"
            :disabled="isLoading"
          />
        </v-flex>
        <v-flex xs12>
          <ControlAutoComplete
            :items="enabledManufacturerList"
            autocomplete
            multiple
            item-text="name"
            item-value="id"
            v-model="manufacturerIds"
            clearable
            label="Manufacturers"
            :disabled="isLoading"
          />
        </v-flex>
        <v-flex xs12>
          <ControlAutoComplete
            :items="enabledCategoryList"
            autocomplete
            multiple
            item-text="name"
            item-value="id"
            v-model="categoryIds"
            clearable
            label="Categories"
            :disabled="isLoading"
          />
        </v-flex>
        <v-flex xs12>
          <ControlAutoComplete
            :items="enabledLocationList"
            v-model="locationIds"
            autocomplete
            multiple
            item-text="name"
            item-value="id"
            clearable
            label="Locations"
            :disabled="isLoading"
          />
        </v-flex>
        <v-flex xs12>
          <ControlAutoComplete
            :items="enabledClientList"
            v-model="ownerIds"
            autocomplete
            multiple
            item-text="name"
            item-value="id"
            clearable
            label="Owners"
            :disabled="isLoading"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </DialogContainer>
</template>

<script>
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'

import DialogContainer from '../../../common/components/layouts/DialogContainer'
import ControlAutoComplete from '../../../common/components/controls/ControlAutoComplete'

export default {
  components: {
    DialogContainer,
    ControlAutoComplete,
  },
  mixins: [mixinAssetHelper],
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    filtersToEdit: {
      type: Object,
      required: true,
    },
    modelList: {
      type: Array,
      required: true,
    },
    manufacturerList: {
      type: Array,
      required: true,
    },
    categoryList: {
      type: Array,
      required: true,
    },
    activityTypeList: {
      type: Array,
      required: true,
    },
    locationList: {
      type: Array,
      required: true,
    },
    clientList: {
      type: Array,
      required: true,
    },
    assetStatusList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    statusIds: null,
    activityTypeIds: null,
    modelIds: null,
    categoryIds: null,
    locationIds: null,
    ownerIds: null,
    manufacturerIds: null,
  }),
  computed: {
    enabledActivityTypeList() {
      return this.activityTypeList.filter(
        (activityType) => activityType.isEnabled
      )
    },
    enabledLocationList() {
      return this.locationList.filter((location) => location.isEnabled)
    },
    enabledAssetStatusList() {
      return this.assetStatusList.filter((status) => status.isEnabled)
    },
    enabledClientList() {
      return this.clientList.filter((client) => client.isEnabled)
    },
    enabledCategoryList() {
      return this.categoryList.filter((category) => category.isEnabled)
    },
    enabledManufacturerList() {
      return this.manufacturerList.filter(
        (manufacturer) => manufacturer.isEnabled
      )
    },
    enabledModelList() {
      return this.modelList.filter((model) => model.isEnabled)
    },
  },
  watch: {
    showDialog() {
      if (this.showDialog && this.filtersToEdit) {
        this.statusIds = this.filtersToEdit.statusIds || []
        this.activityTypeIds = this.filtersToEdit.activityTypeIds || []
        this.modelIds = this.filtersToEdit.modelIds || []
        this.categoryIds = this.filtersToEdit.categoryIds || []
        this.locationIds = this.filtersToEdit.locationIds || []
        this.ownerIds = this.filtersToEdit.ownerIds || []
        this.manufacturerIds = this.filtersToEdit.manufacturerIds || []
      }
      if (!this.showDialog) {
        this.clearDialog()
      }
    },
  },
  methods: {
    onSubmitClicked() {
      this.$emit('onSubmitClicked', {
        statusIds: this.statusIds,
        activityTypeIds: this.activityTypeIds,
        modelIds: this.modelIds,
        categoryIds: this.categoryIds,
        locationIds: this.locationIds,
        ownerIds: this.ownerIds,
        manufacturerIds: this.manufacturerIds,
      })
    },
    onCancelClicked() {
      this.$emit('onCancelClicked')
    },
    clearDialog() {
      this.$refs.form.reset()
      this.statusIds = null
      this.activityTypeIds = null
      this.modelIds = null
      this.categoryIds = null
      this.locationIds = null
      this.ownerIds = null
      this.manufacturerIds = null
    },
  },
}
</script>